// Collection of all the content that is used in the slides.
// Array is consumed by a .map and displayed in order by carousel.

import pictureStep1 from '../assets/HIW_steps_1.jpg';
import pictureStep2 from '../assets/HIW_steps_2.jpg';
import pictureStep3 from '../assets/GS_steps_3.jpg';
import pictureStep4 from '../assets/HIW_steps_4.jpg';


const slideCollection = [
  {
    slideStepTitle: 'Step 1',
    mainTitle: 'Create Your Account',
    bodyContent: `Complete your account profile online at RealtyMogul.com,
      and share your investing goals with us. The process is quick and simple.`,
    image: pictureStep1,
  },
  {
    slideStepTitle: 'Step 2',
    mainTitle: 'Select Your Investment',
    bodyContent: `After you create an online account, select which MogulREIT offering
      you would like to invest in: MogulREIT I or
      MogulREIT II. Click Invest, enter your
      Personal Information, and under "Ownership Information" select "Retirement."`,
    image: pictureStep2,
  },
  {
    slideStepTitle: 'Step 3',
    mainTitle: 'Fund Your Investment',
    bodyContent: `Our team will coordinate with you and your chosen SDIRA custodian to
      either process your investment into MogulREIT I
      or MogulREIT II directly from your
      existing SDIRA, or assist you with transferring funds to a new SDIRA custodian and
      subsequently with completing the investment.
`,
    image: pictureStep3,
  },
  {
    slideStepTitle: 'Step 4',
    mainTitle: 'Track Your Investments',
    bodyContent: `Once your investment is placed, you have full visibility into the
      performance of your investment via the RealtyMogul dashboard. Track your total
      current invested value and distributions.`,
    image: pictureStep4,
  },
];

export default slideCollection;
